import styled from "@emotion/styled";

export const Wrap = styled("div")`
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 100dvw;
  height: 100dvh;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
`;
export const DepartmentTitle = styled("h1")`
  color: var(--purple);
  text-decoration: none;
  margin: 30px;
  font-family: "godorounded", sans-serif;
  font-weight: bold;
  font-size: large;
  background-color: var(--black);
`;
